import { render, staticRenderFns } from "./display.vue?vue&type=template&id=b263c36c&scoped=true"
import script from "./display.js?vue&type=script&lang=js&external"
export * from "./display.js?vue&type=script&lang=js&external"
import style0 from "./display.scss?vue&type=style&index=0&id=b263c36c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b263c36c",
  null
  
)

export default component.exports